module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "software-select"
  }, [_c('v-select', {
    ref: "select",
    attrs: {
      "taggable": _vm.canCreate,
      "filterable": false,
      "closeOnSelect": false,
      "options": _vm.results,
      "placeholder": _vm.placeholder
    },
    on: {
      "search": _vm.search,
      "input": _vm.select
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.handleEmptySearch($event)
      }
    }
  }, [_c('template', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("\n      Search software...\n    ")])], 2), _vm._v(" "), _c('ul', {
    staticClass: "software-list"
  }, _vm._l((_vm.value), function(software, index) {
    return _c('li', [_c('button', {
      staticClass: "delete-btn",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deselect(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('software-item', {
      attrs: {
        "software": software
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f13e456a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/software-select/index.vue
// module id = 2145
// module chunks = 2